export default __webpack_public_path__ + "static/media/Vicious Drape.facd989b.jpg";